export const numberFormatterWithDecimalAndThousand = (num, decimals = 2) => {
  try {
    if (typeof num !== 'number' && !isNaN(parseFloat(num))) {
      num = parseFloat(num)
    }

    if (num && typeof num === 'number') {
      let [integerPart, decimalPart] = num.toFixed(decimals).split('.')

      integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.')

      if (decimalPart) {
        return `${integerPart},${decimalPart}`
      } else {
        return integerPart
      }
    }
    return num
  } catch (error) {
    return num
  }
}
